import { Grid, IconButton, Typography, Tabs, Tab, Box, Paper, Button } from "@mui/material";
import { WSIcons } from "../../commonFunctions/iIcons";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SalesReport } from "./SalesReport";
import { CashierSalesReport } from "./CashierSalesReport";
import { ServingPeriodReport } from "./ServingperiodReport";
import { MenuItemSalesReport } from "./MenuItemSalesReport";
import { VoidTransactionisting } from "./VoidTransactionListing";
import { TimeWiseReport } from "./TimeWiseReport";
import { SalesReportAr } from './SalesReportARAP';
import { FlashReport } from "./FlashReport";
import { SessionWiseReport } from "./SessionWiseReport";
import { PaymentTypeReport } from "./PaymentTypeReport";



export const Report: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);

  const handleClick = (path: string) => {
    navigate(path);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  const tabNames = [
    "Sales Report",
    "Cashier Sales Report",
    "Serving Period Summary Report",
    "Menu Item Sales Report",
    "Void Transaction Listing",
    "Time Wise Item Sales Report",
    "Sales Report With A/R_A/P",
    "Flash Report TerminalWise",
    "Cashier Sales Sessionwise Report",
    "Payment Type Listing Report by Receipt Wise",
  ];

  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      {/* Left Side Content */}
      <Grid item xs={9} sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Grid container direction="column" sx={{ flexGrow: 1 }}>
          {/* Header Section */}
          <Grid item>
            <Typography variant="h6" sx={{ color: "green", padding: '16px' }}> {/* Added padding */}
              {tabNames[selectedTab]} {/* Dynamically update heading */}
            </Typography>
          </Grid>

          {/* Dynamic Content Based on Selected Tab */}
          <Grid item sx={{ mt: 4, flexGrow: 1 }}>
            <Grid sx={{ p: 2, paddingTop: '16px', paddingBottom: '16px' }}> {/* Added padding */}
              {selectedTab === 0 && <SalesReport />}
              {selectedTab === 1 && <CashierSalesReport />}
              {selectedTab === 2 && <ServingPeriodReport />}
              {selectedTab === 3 && <MenuItemSalesReport />}
              {selectedTab === 4 && <VoidTransactionisting />}
              {selectedTab === 5 && <TimeWiseReport />}
              {selectedTab === 6 && <SalesReportAr />}
              {selectedTab === 7 && <FlashReport />}
              {selectedTab === 8 && <SessionWiseReport />}
              {selectedTab === 9 && <PaymentTypeReport />}
            </Grid>
          </Grid>

          {/* Add Footer Here */}
          <Grid
  item
  sx={{
    backgroundColor: "#333",
    padding: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  {/* Left-aligned items: icon and one button */}
  <Grid
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "1rem", // space between icon and button
    }}
  >
    <WSIcons.GTranslateIcon sx={{ color: "white" }} />
    
  </Grid>

  {/* Right-aligned items: two buttons */}
  <Grid
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "1rem", // space between the buttons
    }}
  >
    <Button
      variant="outlined"
      sx={{
        color: "white",
        borderColor: "green",
        "&:hover": {
          backgroundColor: "#2e7d32",
        },
      }}
    >
      Reset
    </Button>
    <Button
      variant="outlined"
      sx={{
        color: "white",
        borderColor: "green",
        "&:hover": {
          backgroundColor: "#2e7d32",
        },
      }}
    >
      Print Preview
    </Button>
    <Button
      variant="contained"
      sx={{
        backgroundColor: "green",
        "&:hover": {
          backgroundColor: "#388e3c",
        },
      }}
    >
      Print
    </Button>
  </Grid>
</Grid>
        </Grid>
      </Grid>

      {/* Right Side Close Icon and Vertical Tabs */}
      <Grid item xs={3} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* Close Icon */}
        <Grid item sx={{ alignSelf: 'flex-end', padding: '16px' }}>
          <IconButton>
            <WSIcons.CloseIcon
              sx={{ backgroundColor: 'red', color: 'white' }}
              onClick={() => handleClick('/')}
            />
          </IconButton>
        </Grid>

        {/* Vertical Tabs below the close button */}
        <Paper sx={{ mt: 2, width: '100%', height: "100%" }}>
          <Tabs
            orientation="vertical"
            value={selectedTab}
            onChange={handleTabChange}
            sx={{ borderRight: 1, borderColor: 'divider' }}
          >
            {tabNames.map((tab, index) => (
              <Tab key={index} label={tab} />
            ))}
          </Tabs>
        </Paper>
      </Grid>
    </Grid>
  );
});
